// extracted by mini-css-extract-plugin
export default {"title":"cardHeader_title__DqBfD","subTitle":"cardHeader_subTitle__U-BAl"};